import { Provide } from '../ioc-container/ioc-container.ts';

@Provide()
export class LocationWrapper {
	navigate(url: string) {
		window.location.assign(url);
	}

	get path(): string {
		const baseUrl = getBaseUrlPrefix();
		const pathname: string = window.location.pathname;
		if (pathname.startsWith(baseUrl)) {
			return pathname.substring(baseUrl.length);
		}

		return pathname;
	}

	get search(): string {
		return window.location.search;
	}

	url(): string {
		return window.location.toString();
	}
}

function getBaseUrlPrefix(): string {
	const baseUrl = import.meta.env.BASE_URL;
	if (baseUrl.endsWith('/')) {
		return baseUrl.substring(0, baseUrl.length - 1);
	}

	return baseUrl;
}
